import { useCallback, useEffect, useMemo, useState } from 'react';
import { MINIMUM_SEARCH_TERM_LENGTH } from '../../../../config';
import {
  AssetSelectDrawerItemEntry,
  AssetSelectHookResult,
  extractAssetsFromPortfolioFetchAllResponse,
} from './utils';
import { getPortfolioAssetsForSearchAndSelect } from '../../../gqlActions/getPortfolioAssetsForSearchAndSelect.action';

export const usePortfolioAssetSelectAndSearch = (): AssetSelectHookResult => {
  const [assetFilterSearchValue, setAssetFilterSearchValue] = useState('');

  const [isLoading, setIsLoading] = useState(true);

  const [allAssets, setAllAssets] = useState<AssetSelectDrawerItemEntry[]>([]);

  const assets = useMemo(() => {
    if (assetFilterSearchValue.trim().length >= MINIMUM_SEARCH_TERM_LENGTH) {
      const searchTerm = assetFilterSearchValue.toLowerCase().trim();

      return allAssets.filter(
        (asset) =>
          asset.name.toLowerCase().includes(searchTerm) ||
          (asset.symbol && asset.symbol.toLowerCase().includes(searchTerm)),
      );
    }

    return allAssets;
  }, [assetFilterSearchValue, allAssets]);

  const fetchAssets = useCallback(async () => {
    try {
      const { data } = await getPortfolioAssetsForSearchAndSelect();

      return data;
    } catch (error) {
      console.error('Error fetching assets:', error);

      return null;
    }
  }, []);

  const onInputChange = useCallback((newValue: string) => {
    setAssetFilterSearchValue(newValue);
  }, []);

  const clearSearchParams = useCallback(() => {
    setAssetFilterSearchValue('');
  }, []);

  const loadMore = useCallback(async () => {
    return Promise.resolve();
  }, []);

  useEffect(() => {
    const initialFetch = async () => {
      setIsLoading(true);

      const data = await fetchAssets();

      if (data) {
        setAllAssets(
          extractAssetsFromPortfolioFetchAllResponse({ responseData: data }),
        );
      }

      setIsLoading(false);
    };

    initialFetch();
  }, [fetchAssets]);

  return {
    assetGroups: [],
    assets,
    assetFilterSearchValue,
    onInputChange,
    clearSearchParams,
    isLoading,
    canLoadMore: false,
    loadMore,
    groups: undefined,
    setGroups: () => {
      return;
    },
  };
};
